import Pricing from '@/components/Pricing';
import Layout from '@/components/Layout';
import { SITE_DOMAIN } from '@/utils/constants';
import FAQ from '@/components/FAQ';
import { Flex } from '@chakra-ui/react';
import { supabase } from '@/utils/supabase-client';
import { supabaseAdmin } from '@/utils/supabase-admin';
import { useRouter } from 'next/router';
import { useState } from 'react';
import Script from 'next/script';
import DashboardLayout from '@/components/layouts/DashboardLayout';

const PricingPage = ({ user, trial, subscription }) => {
  const pageMeta = {
    title: 'FontVisual Pricing Plans | Get Started for Free',
    description: 'FontVisual Pricing Plans | Get Started for Free',
    url: `${SITE_DOMAIN}/pricing`
  };

  // const { reload } = router.query;
  // const [isReload, setIsReload] = useState(true);

  return (
    <DashboardLayout pageMeta={pageMeta}>
      <Flex
        // w="full"
        p={10}
        alignItems="center"
        justifyContent="center"
        flexDirection="column"
      >
        <Pricing trial={trial} subscription={subscription} />
        <FAQ />
      </Flex>
    </DashboardLayout>
  );
};

export default PricingPage;

export async function getServerSideProps({ req }) {
  const { user } = await supabase.auth.api.getUserByCookie(req);

  if (!user) {
    // If no user, redirect to index.
    return { props: {} };
  }

  // console.log('*** PRICING getServerSideProps user.id ' + user.id);

  // check if user has current subscription trial
  const { data: trial, error: errorTrial } = await supabaseAdmin
    .from('customers')
    .select('*, products(*)')
    .eq('id', user.id)
    .single();

  // if (errorTrial) {
  //   console.log('errorTrial: ' + errorTrial.message);
  // }

  // console.log('getServerSideProps trial', trial);

  // get user's current subscription
  const { data: subscription, error: errorSubscription } = await supabaseAdmin
    .from('subscriptions')
    .select('*, products: subscription_plan_id(*)')
    .in('status', ['trialing', 'active', 'deleted', 'past_due', 'paused'])
    .eq('user_id', user.id)
    .eq(
      'id',
      trial
        ? trial.subscription_id
          ? trial.subscription_id
          : trial.invoice_id
          ? trial.invoice_id
          : -1
        : -1
    )
    .single();

  // if (errorSubscription) {
  //   console.log('errorSubscription: ' + errorSubscription.message);
  //   // If no subscription, just return user
  //   // return { props: { user } };
  // }

  // console.log('getServerSideProps subscription', subscription);

  return {
    props: {
      user,
      trial: trial,
      subscription: subscription
    }
  };
}
